import * as config from '../config'

const Config = {
  host: config.DOMAIN_API_DEFAULT,
  endpoints: {
    auth: {
      checkAuth: {
        method: 'get',
        path: '/DesktopBackendBiz/game/qr/checkAuth',
      },
      checkAuthSso: {
        method: 'post',
        path: '/ReengBackendBiz/login-web/sso',
      },
    },
    chat: {
      recallMessage: {
        method: 'post',
        path: '/DesktopBackendBiz/restore/message/v2',
      },
      block: {
        method: 'post',
        path: '/DesktopBackendBiz/block/setBlockChat/v5',
      },
      blockList: {
        method: 'get',
        path: '/DesktopBackendBiz/block/getBlockList/v5',
      },
    },

    group: {
      getListGroup: {
        method: 'get',
        path: '/DesktopBackendBiz/mucroom/getlist/v2',
      },

      createVote: {
        method: 'post',
        path: '/DesktopBackendBiz/poll/create/v2',
      },
      getVoteInfo: {
        method: 'get',
        path: '/DesktopBackendBiz/poll/find/byId/v2',
      },
      vote: {
        method: 'post',
        path: '/DesktopBackendBiz/poll/vote/v2',
      },
      addVote: {
        method: 'post',
        path: '/DesktopBackendBiz/poll/addMore/V2',
      },
      uploadAvatar: {
        method: 'post',
        path: '/api/group/upload',
      },
      getGroupDetail: {
        method: 'get',
        path: '/DesktopBackendBiz/invite-group/getGroupDetails',
      },
      addPendingMember: {
        method: 'post',
        path: '/DesktopBackendBiz/invite-group/addPendingMember',
      },
      getPendingMember: {
        method: 'get',
        path: '/DesktopBackendBiz/invite-group/getPendingMembers',
      },
      setPendingMemberAction: {
        method: 'post',
        path: '/DesktopBackendBiz/invite-group/setAction',
      },
      setApprovals: {
        method: 'post',
        path: '/DesktopBackendBiz/invite-group/setApprovals',
      },
      setLinkState: {
        method: 'post',
        path: '/DesktopBackendBiz/invite-group/setLinkState',
      }
    },

    contact: {
      getProfile: {
        method: 'get',
        path: '/DesktopBackendBiz/user/getUserInfo/v3',
      },
      setProfile: {
        method: 'post',
        path: '/DesktopBackendBiz/user/setUserInfo/v3',
      },
      updateAvatar: {
        method: 'post',
        path: '/DesktopBackendBiz/upload/avatar/v3',
      },
      updateAvatarMobile: {
        method: 'post',
        path: '/ReengBackendBiz/upload/avatar/v3',
      },
      getContacts: {
        method: 'get',
        path: '/DesktopBackendBiz/contact/getContact/v5',
      },
      addContacts: {
        method: 'post',
        path: '/DesktopBackendBiz/contact/addContact/v3',
      },
      removeContacts: {
        method: 'post',
        path: '/DesktopBackendBiz/contact/removeContact/v3',
      },
      getNaNProfile: {
        method: 'get',
        path: '/DesktopBackendBiz/user/getProfile/v1',
      },
      getOfficialAccount: {
        method: 'get',
        path: '/DesktopBackendBiz/config/getOfficalAcount/v2',
      },
    },

    sticker: {
      getCollections: {
        method: 'get',
        path: '/DesktopBackendBiz/sticker/getAllCollection/v2.2',
      },
      downloadCollection: {
        method: 'get',
        path: '/DesktopBackendBiz/downloadSticker/v21',
      },
    },

    config: {
      getConfig: {
        method: 'get',
        path: '/DesktopBackendBiz/config/getConfig/v2.2',
      },
      getConfigApp: {
        method: 'post',
        path: '/DesktopBackendBiz/settingApp/get',
      },
      setConfigApp: {
        method: 'post',
        path: '/DesktopBackendBiz/settingApp/set',
      },
    },

    restore: {
      restoreBackupMsg: {
        method: 'get',
        path: '/DesktopBackendBiz/backupmessage/list',
      },
    },

    friend: {
      getFriendList: {
        method: 'get',
        path: '/onMediaBackendBiz/onmedia/relationship/list/friends',
      },
      addFriend: {
        method: 'post',
        path: '/onMediaBackendBiz/onmedia/relationship/sender/requestFriend',
      },
      senderCancelRequest: {
        method: 'post',
        path: '/onMediaBackendBiz/onmedia/relationship/sender/cancelRequest',
      },
      receiverCancelRequest: {
        method: 'post',
        path: '/onMediaBackendBiz/onmedia/relationship/receiver/cancelRequest',
      },
      acceptFriend: {
        method: 'post',
        path: '/onMediaBackendBiz/onmedia/relationship/receiver/acceptRequest',
      },
      cancelFriend: {
        method: 'post',
        path: '/onMediaBackendBiz/onmedia/relationship/cancelFriend',
      },
      friendStatus: {
        method: 'get',
        path: '/onMediaBackendBiz/onmedia/relationship/status',
      },
      suggestFriend: {
        method: 'get',
        path: '/onMediaBackendBiz/onmedia/suggest/ct',
      },
    },

    officialAccount: {
      actionList: {
        // host: 'http://hlvip2.mocha.com.vn:80',
        host: 'http://localhost:8681',
        method: 'get',
        path: '/ReengBackendBiz/feedback/getServiceActionList/v2',
      },
      getAction: {
        // host: 'http://hlvip2.mocha.com.vn:80',
        host: 'http://localhost:8681',
        method: 'get',
        path: '/ReengBackendBiz/feedback/getAction/v2',
      },
    },

    log: {
      save: {
        method: 'post',
        path: '/ReengBackendBiz/sendlogs/save/v2',
      },
      upload: {
        method: 'post',
        path: '/DesktopBackendBiz/pc/log/upload',
      },
      v2: {
        host: 'https://onmedia.mocha.com.vn',
        method: 'post',
        path: '/ReengBackendBiz/mlog/log',
      }
    },

    media: {
      getMetadata: {
        // host: 'https://devapi.mocha.com.vn',
        method: 'get',
        path: '/onMediaBackendBiz/onmedia/getMetadata',
      },
    },

    versionInfo: {
      getVersionInfo: {
        method: 'get',
        path: '/DesktopBackendBiz/version/pc/latest/get',
      },
    },

    savedMessages: {
      deleteAllMessage: {
        method: 'post',
        path: '/ReengBackendBiz/syncPlatform/delete-all',
      },
      deleteMessage: {
        method: 'post',
        path: '/ReengBackendBiz/syncPlatform/delete',
      },
      editAllMessage: {
        method: 'post',
        path: '/ReengBackendBiz/syncPlatform/edit-message',
      },
      getListMessage: {
        method: 'get',
        path: '/ReengBackendBiz/syncPlatform/list-messages',
      },
      saveMessage: {
        method: 'post',
        path: '/ReengBackendBiz/syncPlatform/save-message',
      },
      saveMultiple: {
        method: 'post',
        path: '/ReengBackendBiz/syncPlatform/save-multiple',
      },
    }
  }
}

export default Config;